import { render } from "./nasaha_form.vue?vue&type=template&id=05712cc0"
import script from "./nasaha_form.vue?vue&type=script&lang=js"
export * from "./nasaha_form.vue?vue&type=script&lang=js"
script.render = render

export default script